import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'multi-select-specs',
  templateUrl: './multi-select-specs.component.html',
  styleUrls: ['./multi-select-specs.component.sass']
})
export class MultiSelectSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/multiselect-dropdown/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
